/* ADD NOTES */
export const ADD_NOTE = "ADD_NOTE"
export const ADD_NOTE_SUCCESS = "ADD_NOTE_SUCCESS"
export const ADD_NOTE_CLEAN = "ADD_NOTE_CLEAN"
export const ADD_NOTE_ERROR = "ADD_NOTE_ERROR"
